import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';

export const SyncFullMexGlobalFilterOperations = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `mex-global-filter/sync-full`,
    {
      headers,
    }
  );
};
